module.exports = __webpack_public_path__ + "static/media/icotrash.d6d44831.svg";